module.exports = __webpack_public_path__ + "static/media/multistream_icon.81f3ea39.svg";